<script lang="ts">
	import { convertSlug } from '#lib/util.js';

	const { data } = $props();
</script>

<svelte:head>
	<title>Tigers Paternion | Archiv</title>
	<meta
		name="description"
		content="Website der Eishockey Clubs Tigers Paternion und Wildcats Paternion"
	/>
</svelte:head>

<div class="grid grid-cols-2 gap-3 md:grid-cols-4">
	{#each data.seasons as season}
		<a
			class="bg-base-100 shadow-accent/10 grid place-content-center py-3 text-2xl font-bold tracking-wider uppercase hover:shadow-xl"
			href={convertSlug(season.slug, 'saison/{slug}')}
		>
			{season.title}
		</a>
	{/each}
</div>
